// Import MantineProvider to use Mantine components
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";

const MantineProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <MantineProvider
      theme={{
        fontFamily: "var(--font-text)",
      }}
    >
      <Notifications position="bottom-right" mb={100} limit={2} />
      {children}
    </MantineProvider>
  );
};

export default MantineProviderWrapper;
